<template lang="pug">
    div(:class='{fixed: fixed === true}', :style='{top: top}')
        .input-field
            select#cityFilters(@change='searchByCity')
                option(:selected='selectedCity === null', :value='"all"') All
                option(v-for='city in cities', :value='city.name', :selected='selectedCity === city.name') {{city.name}}
            label Search by city
</template>
<script>
/* eslint-disable no-undef */
export default {
  props: [
    'fixed',
    'top',
    'onSearchByCity',
    'selectedCity'
  ],
  created () {
    this.$store.dispatch('config/getCities')
  },
  mounted () {
    var elems = document.querySelectorAll('select')
    this.$M.FormSelect.init(elems, {})
  },
  watch: {
    '$store.state.config.cities' () {
      this.initializeCities()
    }
  },
  computed: {
    cities () {
      if (this.$store.state.config.cities) {
        let cities = []
        for (let key in this.$store.state.config.cities) {
          cities.push({
            id: key,
            name: this.$store.state.config.cities[key]
          })
        }

        return cities
      }

      return []
    }
  },
  methods: {
    initializeCities () {
      var elems = document.querySelectorAll('select')
      this.$M.FormSelect.init(elems, {})
    },
    searchByCity (e) {
      this.$emit('onSearchByCity', e.target.value)
      if (typeof this.onSearchByCity === 'function') {
        this.onSearchByCity(e.target.value)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/app-supplier-filter.vue